import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 4AA98685-EEBB-4816-801E-3B12DCB4413F
 * name format-list-bulleted-square
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-list-bulleted-square.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatListBulletedSquareIcon = createSvgIcon(<><path d="M3,4H7V8H3V4M9,5V7H21V5H9M3,10H7V14H3V10M9,11V13H21V11H9M3,16H7V20H3V16M9,17V19H21V17H9" /></>, 'FormatListBulletedSquareIcon');
export default FormatListBulletedSquareIcon